const themes = [
  {
    key: "default",
    color: "#F847CA",
    type: 'light',
    img_cover: 'cover-default.webp',
  },
]

function load() {
  const now = new Date()
  const theme = themes.find(t =>
    t.date_min != null &&
    t.date_max != null &&
    now > new Date(t.date_min) &&
    now < new Date(t.date_max))
  if (theme != null)
    return theme
  return themes[0]
}

const theme = load()

export default theme